import React from 'react'
import DatoCTA from 'js/components/DatoCTA/DatoCTA'

type Props = {
  appButtons: {
    useOfficialButton: boolean
    buttonText?: string
    color: 'green' | 'orange'
    orange
    webSignup: boolean
  }
}
export default function AppButtonBlock(props: Props) {
  return <DatoCTA {...props.appButtons} />
}
